export default __webpack_public_path__ + "static/media/trade_05.2dc79a1d.png";